import { DEFAULT_ERROR_MESSAGE } from '../data-types/initialisation/initialisationConstants';
import { Reward } from '../data-types/rewards/rewardsInterfaces';
import { SIGNUP_CHECKPOINT } from '../data-types/signup/signupEnums';
import {
  SignupCheckpoint,
  SignupCheckpointFinishedResponse,
  SignupCheckpointPassed,
  SignupCredsPayload,
  SignupCustomRequestWithinCheckpointWithDynamicEndpointPayload,
  SignupCustomRequestWithinCheckpointWithDynamicEndpointResponse,
  SignupV3StartResponse,
} from '../data-types/signup/signupInterfaces';
import { PaymentMethodWithNoAccounts } from '../data-types/wallet/walletInterfaces';
import { signupv3Start } from '../socket-types/signupSocketTypes';
import { getPartialDynamicPayloadTemplateOptions } from '../utils/signup';
import { sendCommand } from './commandsHandler';

export const startSignup = async (): Promise<SignupCheckpoint> => {
  const res = await sendCommand<SignupV3StartResponse>(signupv3Start, {});

  if (res.error) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  return res.data;
};

export const signupCreds = async (endpoint: string, payload: SignupCredsPayload): Promise<SignupCheckpointPassed> => {
  const res = await sendCommand<SignupCheckpointFinishedResponse>(endpoint, payload);

  if (res.error) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (res.data) {
    return res.data;
  }

  throw new Error(DEFAULT_ERROR_MESSAGE);
};

export const signupCustomRequestWithTemplatedPayload = async (
  endpoint: string,
  payload: object,
  options: string[],
): Promise<SignupCheckpointPassed> => {
  const res = await sendCommand<SignupCheckpointFinishedResponse>(endpoint, {
    ...payload,
    ...getPartialDynamicPayloadTemplateOptions(options),
  });

  if (res.error) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  return res.data;
};

export const signupCustomRequestWithinCheckpointWithDynamicEndpoint = async (
  checkpoint: SIGNUP_CHECKPOINT,
  endpoint: string,
  payload: SignupCustomRequestWithinCheckpointWithDynamicEndpointPayload,
): Promise<Reward[] | PaymentMethodWithNoAccounts[] | undefined> => {
  const res = await sendCommand<SignupCustomRequestWithinCheckpointWithDynamicEndpointResponse>(endpoint, payload);

  if (res.error) {
    throw new Error(res.error.notification.userFriendlyMessage);
  }

  if (
    [SIGNUP_CHECKPOINT.UK_OPTIONAL_OPT_IN, SIGNUP_CHECKPOINT.IOM_OPTIONAL_OPT_IN, SIGNUP_CHECKPOINT.BRAZIL_OPTIONAL_OPT_IN].includes(
      checkpoint,
    )
  ) {
    return res.data as Reward[];
  }

  if ([SIGNUP_CHECKPOINT.UK_CREDS, SIGNUP_CHECKPOINT.IOM_CREDS, SIGNUP_CHECKPOINT.BRAZIL_CREDS].includes(checkpoint)) {
    return res.data as PaymentMethodWithNoAccounts[];
  }

  return undefined;
};
